import { Temporal } from 'temporal-polyfill'

import { convertTemporalPlainDateToJsDate } from '../../../utils/date'
import { type Move } from './models/move.model'
import { type MoveJob } from './models/subModels/moveJob.model'
import { ArrivalWindow, getArrivalWindowDepartureTime } from '../../../common/arrivalWindow'

export const getPromoCode = (move: Move) => {
  return move.promoCode.appliedPromoCode ?? move.promoCode.pendingPromoCode
}

export const getFirstJobStartDate = (move: Move) => {
  const job = move.jobs[0]
  const startDate = job.dateTime.startDate
  return convertTemporalPlainDateToJsDate(startDate, getJobTime(job))
}

export const getLastJobStartDate = (move: Move) => {
  const job = move.jobs[move.jobs.length - 1]
  const startDate = job.dateTime.startDate
  return convertTemporalPlainDateToJsDate(startDate, getJobTime(job))
}

/**
 * return starting time of a job as Temporal.PlainTime
 */
export const getJobTime = (job: MoveJob) => {
  const dateTime = job.dateTime

  if (dateTime.selectedTime) {
    return Temporal.PlainTime.from(dateTime.selectedTime)
  }
  const preferredTimeRange =
    dateTime.selectedTimeRange ??
    dateTime.preferredTimeRanges?.[0] ??
    ArrivalWindow.from8to9

  const formattedTime = String(
    getArrivalWindowDepartureTime(preferredTimeRange),
  ).padStart(2, '0')

  return Temporal.PlainTime.from(formattedTime)
}
